import select2 from 'select2'

export default function () {
	// @ts-ignore
	select2()
}
